(function() {
    'use strict';

    angular
        .module('MW.ContactManager.CustomBannerService', [
        ])
        .service('mwCustomBannerService', [
            '$translate',
            'mwBannerService',
            function($translate, mwBannerService) {
                const alertBannerRetry = $translate.instant('icm-outreach__template--alert-banner-retry');
                let openBanners = [];

                this.alertWithRetry = function alertWithRetry(alertBannerText, retryCallback, callbackArgs, callbackThis, attachTo, onModal, allowMulti) {
                    let bannerConfig = {
                        template: `
                            <mw-banner type="'alert'" on-close="$ctrl.close($event)">
                                {{$ctrl.alertBannerText}}
                                <mw-banner-actions>
                                    <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.retry()">{{$ctrl.alertBannerRetry}}</md-button>
                                </mw-banner-actions>
                            </mw-banner>
                        `,
                        controller: class BannerPanel {
                            constructor(mdPanelRef) {
                                'ngInject';

                                this.mdPanelRef = mdPanelRef;
                                this.alertBannerText = alertBannerText;
                                this.alertBannerRetry = alertBannerRetry;
                                this.onModal = onModal;
                            }

                            retry() {
                                this.mdPanelRef.close();

                                retryCallback.apply(callbackThis, callbackArgs);
                            }

                            close() {
                                this.mdPanelRef.close();
                            }
                        }
                    };

                    if(attachTo) {
                        bannerConfig.attachTo = attachTo;
                    }

                    if(!allowMulti) {
                        openBanners.forEach((banner) => {
                            banner.close();
                        });

                        openBanners = [];
                    }

                    mwBannerService.open(bannerConfig)
                        .then((banner) => {
                            openBanners.push(banner);
                        });
                };
            }
        ]);
}());